/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */


angular.module('CanvasWrapper').factory('Layer', LayerFactory);

LayerFactory.$inject = ['PIXI'];
function LayerFactory(PIXI) {
	/**
	 * @namespace Layer
	 * @returns {CanvasWrapper.Layer}
	 * @memberOf CanvasWrapper
	 * @constructor
	 */
	let Layer = function(name) {
		this.container = new PIXI.Container();
		this.name = name;
	};

	Layer.prototype.get = function() {
		return this.container;
	};

	Layer.prototype.getName = function() {
		return this.name;
	};

	Layer.prototype.getChildren = function() {
		return this.container.children;
	};

	Layer.prototype.cullChildren = function(begin, end) {
		return this.container.removeChildren(begin, end);
	};

	return Layer;
}
